"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectDrillTargetsByWidgetRef = exports.selectDrillTargets = void 0;
var tslib_1 = require("tslib");
var drillTargetsEntityAdapter_1 = require("./drillTargetsEntityAdapter");
var memoize_1 = tslib_1.__importDefault(require("lodash/memoize"));
var toolkit_1 = require("@reduxjs/toolkit");
var sdk_model_1 = require("@gooddata/sdk-model");
var objRefMap_1 = require("../../../_staging/metadata/objRefMap");
var entitySelectors = drillTargetsEntityAdapter_1.drillTargetsAdapter.getSelectors(function (state) { return state.drillTargets; });
var selectDrillTargetsInternal = entitySelectors.selectAll;
/**
 * Return all widgets drill targets
 * @alpha
 */
exports.selectDrillTargets = toolkit_1.createSelector(selectDrillTargetsInternal, function (drillTargets) {
    return objRefMap_1.newMapForObjectWithIdentity(drillTargets);
});
/**
 * Selects drill targets by widget ref.
 *
 * @alpha
 */
exports.selectDrillTargetsByWidgetRef = memoize_1.default(function (ref) {
    return toolkit_1.createSelector(exports.selectDrillTargets, function (drillTargets) {
        return drillTargets.get(ref);
    });
}, sdk_model_1.serializeObjRef);
//# sourceMappingURL=drillTargetsSelectors.js.map